import React from "react";
import styles from "./ProductPageQuotesHeader.module.scss";
import cx from "classnames";
import SortBy from "../../../../enums/SortBy";

import ProductType from "../../../../../common/interfaces/enums/ProductType";
import QuoteTableViewSwitcher from "../../../../components/Quotes/Components/QuoteTableViewSwitcher/QuoteTableViewSwitcher";
import { QuoteTableView } from "../../../../enums/QuoteTableView";
import SortBySummary from "../../../../components/SortBySummary/SortBySummary";
import { Severity } from "../../../../../common/interfaces/enums/Severity";
import Alert from "../../../../../common/components/Alert/Alert";

interface IProductPageQuotesHeaderProps {
    className?: string;
    productTypes: ProductType[];
    numberOfPolicies: number;
    sortBy: SortBy;
    showMinimumPremiumAlert: boolean;
    isHidden?: boolean;
    isDisabled?: boolean;
    handleChangeSortBy: (newSortBy: SortBy) => void;
    currentView: QuoteTableView;
    setCurrentView: (newView: QuoteTableView) => void;
    switcherAlignment?: React.ComponentProps<typeof QuoteTableViewSwitcher>["align"];
    dropdownInlineLabel?: React.ComponentProps<
        typeof SortBySummary
    >["dropdownInlineLabel"];
    showPreExistingAlert?: boolean;
}

const ProductPageQuotesHeader: React.FC<IProductPageQuotesHeaderProps> = (props) => {
    const {
        className,
        productTypes,
        numberOfPolicies,
        showMinimumPremiumAlert,
        isHidden,
        isDisabled,
        sortBy,
        handleChangeSortBy,
        currentView,
        setCurrentView,
        children,
        showPreExistingAlert
    } = props;

    if (isHidden) return null;

    return (
        <div
            className={cx([
                styles["container"],
                styles["container--spaced-left"],
                "layout-flex-column",
                {
                    [className]: !!className
                }
            ])}>
            <React.Fragment>
                <SortBySummary
                    productType={productTypes}
                    numberOfPolicies={numberOfPolicies}
                    sortBy={sortBy}
                    handleChangeSortBy={handleChangeSortBy}
                    isDisabled={isDisabled}
                    component="summary"
                />
                {showMinimumPremiumAlert && (
                    <Alert severity={Severity.Error}>
                        Premiums with an asterisk (
                        <span className={cx("text-error")}>*</span>) fall below the
                        insurer&apos;s minimum premium requirement.{" "}
                        <a href="/compare/products/edit">
                            Edit cover settings and increase cover where possible.
                        </a>
                    </Alert>
                )}
                {showPreExistingAlert && (
                    <Alert severity={Severity.Info}>
                        Do you want cover for pre-existing conditions?{" "}
                        <a href="/our-service/contact-us.aspx" target="_blank">
                            Discuss your options with us today.
                        </a>
                    </Alert>
                )}
                <div className={cx(styles["header-controls-wrapper"])}>
                    <QuoteTableViewSwitcher
                        className="space-l-non-mobile"
                        currentView={currentView}
                        handleChangeQuoteTableView={setCurrentView}
                        isDisabled={isDisabled}
                        align={props.switcherAlignment || undefined}
                    />
                    <div
                        className={cx(
                            "layout-flex-row--justify-centered",
                            "layout-flex-row--centered",
                            "flex-gap-m"
                        )}>
                        {children}
                        <SortBySummary
                            productType={productTypes}
                            numberOfPolicies={numberOfPolicies}
                            sortBy={sortBy}
                            handleChangeSortBy={handleChangeSortBy}
                            isDisabled={isDisabled}
                            component="dropdown"
                            dropdownInlineLabel={props.dropdownInlineLabel || undefined}
                        />
                    </div>
                </div>
            </React.Fragment>
        </div>
    );
};

export default ProductPageQuotesHeader;
